import { useEffect, useState } from "react";
import logo from "../../assets/images/logo/BannerISFsmall.png";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { UseAuth } from "../../auth/AuthContext";
import ConfirmationLogout from "../Shared/ConfirmationLogout";
import { useAppStateContext } from "../../auth/AppStateContext";
import { BiDollar } from "react-icons/bi";
import ImgBellNotificationAdmin from "src/assets/images/bellnotification.gif";

import {
  classNames,
  formatCurrency,
  getCoinImage,
  getFrozenImage,
  getProfileDefaultImage,
  money,
} from "src/helpers/mixins";
import NavUserAdminNotification from "./NavUserAdminNotification";
import { MdOutlineLogout } from "react-icons/md";
import { Popover, Tooltip } from "antd";
import { BsBell } from "react-icons/bs";
import { HiUser, HiCurrencyDollar, HiOutlineBell } from "react-icons/hi2";
import NotificationUserBody from "./NotificationUserBody";
import useQueryListNotification from "src/hooks/useQueryListNotification";
import { IoClose, IoMenu } from "react-icons/io5";
import APIService from "src/services/Api";
import NotificationAdminBody from "../Admin/NotificationAdminBody";
/* const CashierMovements = lazy(
  () => import("src/components/System/CoinsMovements")
); */
const NavUser = () => {
  const { t } = useTranslation();
  const { user, updateUserData } = UseAuth();
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [showNotificationUser, setShowNotificationUser] = useState<boolean>(false);
  const [showNotificationAdmin, setShowNotificationAdmin] = useState<boolean>(false);

  const { notificationList } = useQueryListNotification(0, user?.id || "");
  const {
    currentDollar,
    currentDollarFiat,
    fetchCurrentDollar,
    cashierCoins,
    frozenCoins,
    adminHouseCoins,
    fetchCashierCoins,
    fetchAdminHouseCoins,
    showMenuMovil,
    setShowMenuMovil,
    setNotifications,
    notifications,
  } = useAppStateContext();
  const navigate = useNavigate();

  const viewNotifications = async () => {
    setShowNotificationUser(true);
    if (notifications.some((n) => !n.seen)) {
      await APIService.systemViewNotifications({
        user: user?.id || "",
        type: "user",
      });
    }
    setNotifications(notificationList.map((n) => ({ ...n, seen: true })));
  };

  const handleVisitDolar = () => {
    if (user?.role === "cashier") {
      navigate("/cashier/dolar");
    }
  };

  useEffect(() => {
    if ((!currentDollar || currentDollar === "0") && (user?.role === "user" || user?.role === "cashier")) {
      fetchCurrentDollar();
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user?.role === "cashier") {
      fetchCashierCoins(user?.id || "");
    } else if (user?.role === "admin") {
      fetchAdminHouseCoins();
    }
  }, [user]);

  useEffect(() => {
    if (!user?.verifiedIdentity) {
      const intervalId = window.setInterval(() => {
        updateUserData();
      }, 15000);
      return () => clearInterval(intervalId);
    } /* else {
      const intervalId = window.setInterval(() => {
        updateUserData();
      }, 20000);
      return () => clearInterval(intervalId);
    } */
  }, []);

  useEffect(() => {
    updateUserData();
  }, []);

  const tooltipUserImage = (
    <div className="flex flex-col gap-2 py-2 min-w-[160px]">
      <Link 
        to={`/usuario/${user?.id}`} 
        className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
      >
        <HiUser size={18} className="text-gray-600" />
        <span className="font-medium">Perfil</span>
      </Link>
      <div
        onClick={() => setShowConfirmation(true)}
        className="flex items-center gap-3 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
      >
        <MdOutlineLogout size={18} />
        <span className="font-medium">Cerrar sesión</span>
      </div>
    </div>
  );

  return (
    <>
      <div>
        <ConfirmationLogout
          show={showConfirmation}
          cancel={() => setShowConfirmation(false)}
          confirm={() => navigate("/salir")}
        />
        {!showNotificationUser && !showNotificationAdmin && (
          <nav
            className="bg-white fixed top-0 left-0 right-0 w-full border-b border-gray-200 shadow-sm"
            style={{ zIndex: "1000" }}
          >
            <div className="container mx-auto px-3 sm:px-4 md:px-6">
              <div className="flex items-center justify-between h-16 md:h-20">
                <div className="flex items-center gap-2 sm:gap-4 md:gap-6 flex-1 min-w-0">
                  <Link to="/inicio" className="flex items-center flex-shrink-0">
                    <img alt="logo" className="h-8 sm:h-10 md:h-12 w-auto" src={logo} />
                  </Link>
                  {user?.role === "admin" && (
                    <div className="hidden sm:flex">
                      <Tooltip
                        title={<div className="text-black font-semibold">Presiona para ver detalle.</div>}
                        color="#fff"
                      >
                        <button
                          onClick={() => navigate("/admin/coins")}
                          className="flex items-center gap-2 px-3 md:px-4 py-2 bg-gradient-to-r from-emerald-50 to-emerald-100 hover:from-emerald-100 hover:to-emerald-200 border border-emerald-200 rounded-xl font-semibold cursor-pointer transition-all duration-200 hover:shadow-md"
                        >
                          <div className="hidden lg:block text-xs text-emerald-700 font-medium">Coins casa</div>
                          <div className="relative">
                            <img src={getCoinImage()} alt="my coins" className="w-5 h-5 md:w-6 md:h-6 object-contain" />
                            <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-yellow-400 rounded-full border-2 border-white shadow-sm"></div>
                          </div>
                          <span className="text-emerald-700 font-bold text-sm">{money(adminHouseCoins || 0)}</span>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                  {user?.role === "cashier" && (
                    <div className="hidden sm:flex">
                      <Tooltip
                        title={<div className="text-black font-semibold">Presiona para ver detalle.</div>}
                        color="#fff"
                      >
                        <button
                          onClick={() => navigate("/cashier/movimientos")}
                          className="flex items-center gap-2 px-3 md:px-4 py-2 bg-gradient-to-r from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 border border-blue-200 rounded-xl font-semibold cursor-pointer transition-all duration-200 hover:shadow-md"
                        >
                          <div className="hidden md:block text-xs text-blue-700 font-medium">ISFCoins</div>
                          <img src={getCoinImage()} alt="my coins" className="w-5 h-5 md:w-6 md:h-6" />
                          <span className="text-blue-700 font-bold text-sm">{formatCurrency(cashierCoins || 0, "USD")}</span>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                  {user?.role === "cashier" && (
                    <div className="hidden lg:flex">
                      <Tooltip
                        title={
                          <div className="text-black">
                            <span className="font-semibold">Coins Congelados</span>
                            <div>
                              Representa el dinero que has recibido. una vez completes el pago, serán descongelados.
                              esto asegura la integridad del flujo del dinero.
                            </div>
                          </div>
                        }
                        color="#fff"
                      >
                        <button
                          onClick={() => navigate("/cashier/movimientos")}
                          className="flex items-center gap-2 px-3 md:px-4 py-2 bg-gradient-to-r from-amber-50 to-amber-100 hover:from-amber-100 hover:to-amber-200 border border-amber-200 rounded-xl font-semibold cursor-pointer transition-all duration-200 hover:shadow-md"
                        >
                          <div className="text-xs text-amber-700 font-medium">Congelados</div>
                          <div className="relative">
                            <img
                              src={getFrozenImage()}
                              alt="my frozen coins"
                              className="w-6 h-6 z-20 relative opacity-80"
                            />
                            <img
                              src={getCoinImage()}
                              alt="my coins"
                              className="w-5 h-5 absolute top-0 right-0 z-10"
                            />
                          </div>
                          <span className="text-amber-700 font-bold text-sm">{formatCurrency(frozenCoins || 0, "USD")}</span>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                  {(user?.role === "cashier" || user?.role === "user") && (
                    <div className="hidden sm:flex">
                      <Tooltip
                        color="#fff"
                        title={
                          <div className="text-black font-semibold">
                            Precio dólar
                            <div className="font-normal">
                              Este monto representa el precio del dólar dentro de la plataforma.
                            </div>
                          </div>
                        }
                      >
                        <button
                          onClick={() => handleVisitDolar()}
                          className={classNames(
                            (currentDollar || 0) === 0 
                              ? "bg-red-100 border-red-300 text-red-700" 
                              : "bg-gradient-to-r from-emerald-50 to-emerald-100 hover:from-emerald-100 hover:to-emerald-200 border-emerald-200 text-emerald-700",
                            "flex items-center gap-2 px-3 md:px-4 py-2 border rounded-xl font-semibold cursor-pointer transition-all duration-200 hover:shadow-md"
                          )}
                        >
                          <HiCurrencyDollar className="text-current" size={18} />
                          <span className="hidden lg:block text-xs font-medium">{t("changetoday")}</span>
                          <span className="text-sm font-bold">
                            {(currentDollarFiat || "usd").toUpperCase()} ${money(currentDollar)}
                          </span>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-2 sm:gap-3">
                    {user?.role !== "admin" && (
                      <div
                        onClick={() => viewNotifications()}
                        className="relative p-2 rounded-full hover:bg-gray-100 cursor-pointer transition-all duration-200"
                      >
                        {notifications.filter((n) => !n.seen).length > 0 && (
                          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 border-white shadow-sm">
                            {notifications.filter((n) => !n.seen).length}
                          </span>
                        )}
                        {notifications.some((n) => !n.seen) ? (
                          <img src={ImgBellNotificationAdmin} className="w-6 h-6 md:w-7 md:h-7" alt="notificaciones" />
                        ) : (
                          <HiOutlineBell className="text-gray-700" size={24} />
                        )}
                      </div>
                    )}
                    {user?.role === "admin" && (
                      <div>
                        <NavUserAdminNotification handleShowNav={setShowNotificationAdmin} />
                      </div>
                    )}
                    <Popover content={tooltipUserImage} trigger="click">
                      <div className="cursor-pointer">
                        <div
                          className="w-8 h-8 sm:w-10 sm:h-10 bg-cover bg-center rounded-full border-2 border-gray-200 hover:border-emerald-500 transition-all duration-200 shadow-sm hover:shadow-md"
                          style={{
                            backgroundImage: `url(${
                              (user?.photoUrl?.length || 0) > 0
                                ? process.env.REACT_APP_PROFILEPICTURE + (user?.photoUrl || "")
                                : getProfileDefaultImage()
                            })`,
                          }}
                        ></div>
                      </div>
                    </Popover>
                    <div className="flex md:hidden">
                      {((user?.role || "") === "cashier" || (user?.role || "") === "user") && (
                        <>
                          {!showMenuMovil ? (
                            <IoMenu size={28} className="cursor-pointer text-gray-700 hover:text-emerald-600 transition-colors" onClick={() => setShowMenuMovil(true)} />
                          ) : (
                            <IoClose size={28} className="cursor-pointer text-gray-700 hover:text-red-600 transition-colors" onClick={() => setShowMenuMovil(false)} />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
          </nav>
        )}
        <div className="relative h-16 md:h-20 w-full"></div>
      </div>

      {showNotificationUser && <NotificationUserBody close={() => setShowNotificationUser(false)} />}
      {showNotificationAdmin && <NotificationAdminBody close={() => setShowNotificationAdmin(false)} />}
    </>
  );
};

export default NavUser;
